var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSoundoffmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 5v14h-2l-4-4h-3a1 1 0 0 1 -1-1v-4a1 1 0 0 1 1-1h3l4-4zm7.47 3.47 1.06 1.06-2.469 2.47 2.47 2.47-1.061 1.06-2.47-2.469-2.47 2.47-1.06-1.061 2.469-2.47-2.47-2.47 1.061-1.06 2.47 2.469 2.47-2.47z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSoundoffmin);
export default __webpack_public_path__ + "static/media/ic_soundoff.min.fa38d291.svg";
export { ForwardRef as ReactComponent };